module.exports = __webpack_public_path__ + "img/SWP_Sword_1H_04 (1).f7fb9f66.png";